import { path } from "ramda";
import { uToArray, uToBoolean, uToNumber, uToObject, uToString } from "./casts";
import { isObject } from "./guards";

function get(obj, valuePath, defaultValue) {
	const splitPath = valuePath.split(".");
	const value = path(splitPath, obj);
	if (value === undefined) {
		return defaultValue;
	}
	return value;
}

function getNumber(obj, valuePath, defaultValue = 0) {
	return uToNumber(get(obj, valuePath, defaultValue));
}

function getString(obj, valuePath, defaultValue = "") {
	return uToString(get(obj, valuePath, defaultValue));
}

function getBoolean(obj, valuePath, defaultValue = false) {
	return uToBoolean(get(obj, valuePath, defaultValue));
}

function getArray(obj, valuePath) {
	return uToArray(get(obj, valuePath, []));
}

function getDate(obj, valuePath) {
	const dateStr = getString(obj, valuePath);
	return dateStr ? new Date(dateStr) : "";
}

function getObject(obj, valuePath) {
	return uToObject(get(obj, valuePath, {}));
}

function hasKey(obj, key) {
	if (!isObject(obj)) {
		return false;
	}
	return key in obj;
}

export {
	get,
	getArray,
	getBoolean,
	getNumber,
	getDate,
	getObject,
	getString,
	hasKey,
};
